import * as React from 'react';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';

interface ProductChildrenViewProps extends ComponentViewProps<DataSet<ProductItem>> {
	mode: ControlMode;
	onItemDoubleClicked?: (item: ProductItem) => any;
	getContractColumn: (item: ProductItem)=>string
}

export class ProductChildrenView extends React.Component<ProductChildrenViewProps, {}> {
	constructor(props) {
		super(props);
	}

	render() {
		const dataService = this.props.model;
		const columns: Column[] = [
			{
				key: 'productType',
				title: 'Type',
				dataIndex: 'productTypeText'
			},
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record, index) => {
					return record.dynamicProperties.displayName.en;
				}
			},
			{
				key: 'Contracts',
				title: 'Contracts',
				dataIndex: 'Contracts',
				render: (text, record, index) => {
					return this.props.getContractColumn(record);
				}
			}
		];

		return (
			<DataTableView
				mode={this.props.mode}
				createNewItem={() => this.props.onItemDoubleClicked(null)}
				setBusy={this.props.setBusy}
				columns={columns}
				model={dataService}
				hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hidePagination | ToolbarVisibility.hideSearch}
				itemDoubleClick={(item) => {
					if (this.props.onItemDoubleClicked) {
						this.props.onItemDoubleClicked(item);
					}
				}}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/form/parts/product-children.view.tsx